import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import ConstData from "../../lib/ConstData";
import { enAdminTap, enManagePage } from "../../lib/ConstCommand";

import {
    getMyRoutingKey
} from "../../lib/RabbitmqClient";

import {
    sendGetState
} from "../../lib/MediaSoupClient";

import {
    changeAlertMessage,
    reportTokenResetCompleted,
    getMyManageSubDomainList,
    resetUserLoginStatus,
    resetUserPW,
    findUser,
    addSubDomainInfo,
    selectSubDomainInfo,
    selectSubDomainConfigInfo,
    selectUserInfo,
    changeSubDomainLogo,
    falseToChangeLogo,
    duplicateCheckSubDomain,
    addSubDomainConfigAdmin,
    removeSubDomainConfigAdmin,
    addSubDomainCreateAdmin,
    removeSubDomainCreateAdmin,
    getSubDomainLocalServerList,
    getUserLocalServerList,
    createLocalServer,
    changeLocalServerPortInfo,
    changeLocalServerConfigInfo,
    getLocalServerTypes,
    updateLocalServerTypeUse,
    updateLocalServerTypesUse,
    getLocalServerCommandInfo,
    sendLocalServerCommand,
    getLocalSiteList,
    createLocalSite,
    deleteLocalSite,
    classOpenOnLocalSite,
    classCloseOnLocalSite,
    getLiteServerList,
    createLiteServer,
    changeLocalSiteInfo,
    changeLiteServerInfo,
    // 20260828 로컬 서버/로컬 사이트 이름 인라인 수정 액션 추가
    changeLocalServerName,
    changeLocalSiteName,
    duplicateCheckUsers,
    createUsers,
    clearRemoteForwardInfo,
    getAllContentTeachers,
    createContentTeachers,
    updateTeacherUseYn,
    updateTeacherName,
    updateTeacherInfo,
    deleteContentTeacher,
    getAllLiveList,
    updateLiveInfo,
    deleteLive,
    getAllContentUrls,
    createContentUrls,
    updateUrlInfo,
    deleteContentUrl,
    getMediaGateWayList
} from "../../modules/admin";

import {
    changeShowPassKind
} from "../../modules/hiclasstv";

import {
    getPurchasePass
} from "../../modules/pass";

import WebStudioContainer from "./WebStudioContainer";

import WebMyConfigSubDomainList from "../../components/admin/WebMyConfigSubDomainList";
import WebMyCreateSubDomainList from "../../components/admin/WebMyCreateSubDomainList";
import WebSubDomainDetailConfig from "../../components/admin/subDomain/WebSubDomainDetailConfig";
import WebMediaConfig from "../../components/admin/WebMediaConfig";
import WebLocalServerConfig from "../../components/admin/WebLocalServerConfig";
import WebLiteServerConfig from "../../components/admin/WebLiteServerConfig";
import WebLocalSiteConfig from "../../components/admin/WebLocalSiteConfig";
import WebTeacherClassConfig from "../../components/admin/WebTeacherClassConfig";
import WebSubDomainDetailInfo from "../../components/admin/subDomain/WebSubDomainDetailInfo";
import WebLocalServerHistory from "../../components/admin/WebLocalServerHistory";

class WebAdminContainer extends Component {
    handleSelectedFunc = ({ selectedFunc, subDomainName, selectedUserSeq, subDomainSeq, mode, password, message, keyword, kind, data, filename, subDomain_info }) => {
        switch (selectedFunc) {
            case "FIND_USER":
                this.props.findUser({
                    kind: "search-user",
                    userKind: subDomainName,
                    keyWord: keyword
                });
                break;

            case "GET_MANAGE_INFO":
                this.props.getMyManageSubDomainList({
                    userSeq: this.props.userSeq,
                    userKind: this.props.userKind
                });
                break;

            case "GET_SERVER_STATE":
                sendGetState();
                break;

            // 260805 관리자 MEDIA 탭용 - 미디어 수프 게이트웨이 서버 전체 목록 조회
            case "GET_MEDIA_GATEWAY_LIST":
                this.props.getMediaGateWayList();
                break;

            case "GET_PCHS_LIST":
                this.props.selectSubDomainInfo({
                    userKind: this.props.userKind,
                    subDomainSeq
                });

                this.props.changeShowPassKind({
                    selectedFunc: "SHOW_PASS_PCHS_LIST"
                });

                if (kind === "SUB_DOMAIN") {
                    this.props.getPurchasePass({
                        term: "all",
                        kindCode: "all",
                        subDomainSeq
                    });
                } /* else {
                    this.props.selectUserInfo({
                        subDomainSeq,
                        selUserSeq: selectedUserSeq
                    });

                    this.props.getPurchasePass({
                        term: "all",
                        kindCode: "all",
                        subDomainSeq,
                        selUserSeq: selectedUserSeq
                    });
                } */

                if (this.props.routeProps.history) {
                    this.props.routeProps.history.push("/pass");
                }
                break;

            case "CHECK_WEB_SUB_DOMAIN":
                this.props.duplicateCheckSubDomain({
                    userSeq: this.props.userSeq,
                    subDomainName
                });
                break;

            case "ADD_OK_WEB_SUB_DOMAIN":
                this.props.addSubDomainInfo({
                    userSeq: this.props.userSeq,
                    subDomainName,
                    data,
                    filename
                });
                break;

            case "RESET_USER_STATUS":
                this.props.resetUserLoginStatus({
                    userSeq: this.props.userSeq,
                    selectedUserSeq,
                    subDomainSeq,
                    mode
                });
                break;

            case "RESET_USER_PW":
                this.props.resetUserPW({
                    userSeq: this.props.userSeq,
                    selectedUserSeq,
                    subDomainSeq,
                    password
                });
                break;

            case "ADD_SUB_DOMAIN_ADMIN":
                this.props.addSubDomainConfigAdmin({
                    userSeq: this.props.userSeq,
                    subDomainSeq,
                    selectedUserSeq
                });
                break;

            case "REMOVE_SUB_DOMAIN_ADMIN":
                this.props.removeSubDomainConfigAdmin({
                    userSeq: this.props.userSeq,
                    subDomainSeq,
                    selectedUserSeq
                });
                break;

            case "ADD_CREATE_SUB_DOMAIN_ADMIN":
                this.props.addSubDomainCreateAdmin({
                    userSeq: this.props.userSeq,
                    subDomainSeq,
                    selectedUserSeq
                });
                break;

            case "REMOVE_CREATE_SUB_DOMAIN_ADMIN":
                this.props.removeSubDomainCreateAdmin({
                    userSeq: this.props.userSeq,
                    subDomainSeq,
                    selectedUserSeq
                });
                break;

            case "CHANGE_ALERT_MESSAGE":
                this.props.changeAlertMessage(message, kind);
                break;

            case "CONFIG_SUB_DOMAIN":
                // this.props.selectSubDomainConfigInfo({ subDomain_info });

                if (this.props.routeProps.history) {
                    this.props.routeProps.history.push(`/admin/subdomain/${subDomain_info.subDomainSeq}`);
                }
                break;

            case "CONFIG_SUB_DOMAIN_MEMBER":
                // this.props.selectSubDomainConfigInfo({ subDomain_info });

                if (this.props.routeProps.history) {
                    this.props.routeProps.history.push(`/admin/subdomain/${subDomain_info.subDomainSeq}/member`);
                }
                break;

            case "CHANGE_LOGO":
                this.props.changeSubDomainLogo({
                    subDomainSeq,
                    subDomainName,
                    data,
                    filename
                });
                break;

            case "FALSE_TO_CHANGE_LOGO":
                this.props.falseToChangeLogo();
                break;

            case "GOTO_SUB_DOMAIN_HOME":
                /* this.props.selectSubDomainConfigInfo({
                    subDomain_info: {
                        selectedIdx: -1,
                        subDomainSeq: -1,
                        subDomainName: ""
                    }
                }); */

                if (this.props.routeProps.history) {
                    this.props.routeProps.history.push("/admin");
                }
                break;

            case "GET_SUB_DOMAIN_LOCAL_SERVER_INFO":
                // 20261023 초기화 후 현재 조회 범위를 그대로 다시 불러온다.
                this.localServerQuery = { subDomainSeq, byUser: false };
                this.props.getSubDomainLocalServerList({ subDomainSeq });
                break;

            case "GET_USER_LOCAL_SERVER_INFO":
                this.localServerQuery = { subDomainSeq, selectedUserSeq, byUser: true };
                this.props.getUserLocalServerList({ subDomainSeq, selectedUserSeq });
                break;

            case "LOCAL_SERVER_TOKEN_RESET_DONE":
                this.props.reportTokenResetCompleted(data);
                if (this.localServerQuery) {
                    if (this.localServerQuery.byUser) this.props.getUserLocalServerList(this.localServerQuery);
                    else this.props.getSubDomainLocalServerList(this.localServerQuery);
                }
                break;

            case "CREATE_LOCAL_SERVER":
                console.log("CREATE_LOCAL_SERVER - ", data);
                this.props.createLocalServer(data);
                break;

            case "LOCAL_SERVER_HISTORY":
                // 20260814 선택한 로컬 서버의 업데이트·포트 이력 페이지로 이동한다.
                if (this.props.routeProps.history) {
                    // 20260819 이력 화면에서 돌아올 때 기존 목록 위치를 복원할 수 있도록 조회 상태를 전달한다.
                    this.props.routeProps.history.push(`/admin/local-server/${data.localServerSeq}/histories`, {
                        localServerListState: data.localServerListState
                    });
                }
                break;

            // 20260814 클라우드에서 관리하는 로컬 서버 타입 기준정보를 조회·변경한다.
            case "GET_LOCAL_SERVER_TYPES":
                this.props.getLocalServerTypes();
                break;

            case "UPDATE_LOCAL_SERVER_TYPE_USE":
                this.props.updateLocalServerTypeUse(data);
                break;

            case "UPDATE_LOCAL_SERVER_TYPES_USE":
                this.props.updateLocalServerTypesUse(data);
                break;

            // 20260828 로컬 서버 명령 capability 조회 및 관리자 명령 발행
            case "GET_LOCAL_SERVER_COMMAND_INFO":
                this.props.getLocalServerCommandInfo({ localServerSeq: data.localServerSeq });
                break;
            case "SEND_LOCAL_SERVER_COMMAND":
                this.props.sendLocalServerCommand({ ...data, replyRoutingKey: getMyRoutingKey() });
                break;

            case "DELETE_LOCAL_SERVER":
                console.log("DELETE_LOCAL_SERVER - ", data);
                // this.props.removeLocalServer();
                break;

            case "CHANGE_LOCAL_SITE":
                console.log("CHANGE_LOCAL_SITE - ", data);
                this.props.changeLocalSiteInfo(data);
                break;

            // 20260828 로컬 서버 이름 인라인 수정 (연필 아이콘 확인 클릭 시 즉시 저장)
            case "CHANGE_LOCAL_SERVER_NAME":
                console.log("CHANGE_LOCAL_SERVER_NAME - ", data);
                this.props.changeLocalServerName(data);
                break;

            case "CHANGE_LOCAL_SERVER_PORT_NUM":
                console.log("CHANGE_LOCAL_SERVER_PORT_NUM - ", data);
                this.props.changeLocalServerPortInfo({
                    localServerSeq: data.localServer_info.localServerSeq,
                    portNumber: data.portNumber,
                    historyMemo: data.historyMemo,
                    status: true,
                    routingKey: getMyRoutingKey()
                });
                break;

            case "CLOSE_LOCAL_SERVER_PORT":
                console.log("CLOSE_LOCAL_SERVER_PORT - ", data);
                this.props.changeLocalServerPortInfo({
                    localServerSeq: data.localServer_info.localServerSeq,
                    historySeq: data.localServer_info.historySeq,
                    status: false,
                    routingKey: getMyRoutingKey()
                });
                break;

            // 260804 로컬서버 상세설정(로그인 허용/자동 로그인/업데이트 허용) 저장
            case "CHANGE_LOCAL_SERVER_CONFIG":
                console.log("CHANGE_LOCAL_SERVER_CONFIG - ", data);
                this.props.changeLocalServerConfigInfo({
                    localServerSeq: data.localServer_info.localServerSeq,
                    allowLoginYn: data.allowLoginYn,
                    autoLoginYn: data.autoLoginYn,
                    updateAllowYn: data.updateAllowYn,
                    // 20260813 클래스 모니터 허용값도 기존 상세설정 저장 흐름으로 전달한다.
                    classMonitorAllowYn: data.classMonitorAllowYn,
                    // 20260814 서버 타입도 기존 상세설정 저장 요청으로 전달한다.
                    localServerType: data.localServerType,
                    localServerTypeName: data.localServerTypeName
                });
                break;

            case "CLEAR_REMOTE_FORWARD_INFO":
                // 20260814 원격 포워딩 정보 초기화 시 반복 출력되는 로그를 비활성화한다.
                // console.log("CLEAR_REMOTE_FORWARD_INFO - ", data);
                this.props.clearRemoteForwardInfo({
                    localServerSeq: data.localServer_info.localServerSeq
                });
                break;

            case "GET_LOCAL_SITE_LIST":
                this.props.getLocalSiteList();
                break;

            case "CREATE_LOCAL_SITE":
                this.props.createLocalSite({ localSiteName: data });
                break;

            case "DELETE_LOCAL_SITE":
                this.props.deleteLocalSite({ localSiteSeq: data });
                break;

            // 20260828 로컬 사이트 이름 인라인 수정 (연필 아이콘 확인 클릭 시 즉시 저장)
            case "CHANGE_LOCAL_SITE_NAME":
                console.log("CHANGE_LOCAL_SITE_NAME - ", data);
                this.props.changeLocalSiteName(data);
                break;

            case "SET_LOCAL_SITE_OPEN":
                console.log("SET_LOCAL_SITE_OPEN - ", data);
                this.props.classOpenOnLocalSite(data);
                break;

            case "SET_LOCAL_SITE_CLOSE":
                console.log("SET_LOCAL_SITE_CLOSE - ", data);
                this.props.classCloseOnLocalSite(data);
                break;

            case "GET_LITE_SERVER_LIST":
                this.props.getLiteServerList();
                break;

            case "CREATE_LITE_SERVER":
                console.log("CREATE_LITE_SERVER - ", data);
                this.props.createLiteServer(data);
                break;

            case "UPDATE_LITE_SERVER":
                console.log("UPDATE_LITE_SERVER - ", data);
                this.props.changeLiteServerInfo({
                    kind: "modify",
                    liteServerSeq: data.liteServerSeq,
                    authCode: data.authCode,
                    liteServerMemo: data.memo
                });
                break;

            case "INIT_LITE_SERVER":
                this.props.changeLiteServerInfo({
                    kind: "init",
                    liteServerSeq: data.liteServerSeq,
                    authCode: data.authCode,
                    initStatus: data.initStatus
                });
                break;

            // 20260828 라이트 로컬 서버 이름 인라인 수정 (연필 아이콘 확인 클릭 시 즉시 저장)
            case "CHANGE_LITE_SERVER_NAME":
                console.log("CHANGE_LITE_SERVER_NAME - ", data);
                this.props.changeLiteServerInfo({
                    kind: "modifyName",
                    liteServerSeq: data.liteServerSeq,
                    authCode: data.authCode,
                    liteServerName: data.liteServerName
                });
                break;

            case "DELETE_LITE_SERVER":
                break;

            case "DUPLICATE_CHECK_USERS":
                this.props.duplicateCheckUsers(data);
                break;

            case "CREATE_USERS":
                this.props.createUsers(data);
                break;

            case "GET_ALL_CONTENT_TEACHERS":
                this.props.getAllContentTeachers({
                    page  : 1,
                    limit : 9999    // 전체 목록을 한 번에 받아서 프론트에서 페이지네이션
                });
                break;

            case "ADD_TEACHERS":
                // list_teacher: [{ teacherName }] 형태로 변환하여 전달
                this.props.createContentTeachers({
                    list_teacher: data.map(name => ({ teacherName: name }))
                });
                break;

            case "TOGGLE_TEACHER_USE_YN":
                this.props.updateTeacherUseYn({
                    teacherSeq: data.teacherSeq,
                    useYn: data.useYn   // "Y" | "N"
                });
                break;

            case "SAVE_TEACHER_NAME":
                this.props.updateTeacherName({
                    teacherSeq: data.teacherSeq,
                    teacherName: data.teacherName
                });
                break;

            case "SAVE_TEACHER_INFO":
                this.props.updateTeacherInfo({
                    teacherSeq: data.teacherSeq,
                    teacherName: data.teacherName,
                    useYn: data.useYn
                });
                break;

            case "DELETE_TEACHER":
                this.props.deleteContentTeacher({
                    teacherSeq: data.teacherSeq
                });
                break;

            case "GET_ALL_CLASSES":
                this.props.getAllLiveList({
                    page  : 1,
                    limit : 9999    // 전체 목록을 한 번에 받아서 프론트에서 페이지네이션
                });
                break;

            case "TOGGLE_CLASS_USE_YN":
                this.props.updateLiveInfo({
                    liveSeq: data.liveSeq,
                    liveName: data.liveName,
                    useYn: data.useYn
                });
                break;

            case "SAVE_CLASS_NAME":
                this.props.updateLiveInfo({
                    liveSeq: data.liveSeq,
                    liveName: data.liveName,
                    useYn: data.useYn
                });
                break;

            case "SAVE_CLASS_INFO":
                this.props.updateLiveInfo({
                    liveSeq: data.liveSeq,
                    liveName: data.liveName,
                    useYn: data.useYn
                });
                break;

            case "DELETE_CLASS":
                this.props.deleteLive({
                    liveSeq: data.liveSeq
                });
                break;

            case "GET_ALL_CONTENT_URLS":
                this.props.getAllContentUrls({
                    page  : 1,
                    limit : 9999    // 전체 목록을 한 번에 받아서 프론트에서 페이지네이션
                });
                break;

            case "ADD_URLS":
                // data: [{ siteName, siteAddress, faviconUrl }, ...]
                this.props.createContentUrls({
                    list_url: data.map(row => ({
                        siteName    : row.siteName,
                        siteAddress : row.siteAddress,
                        faviconUrl  : row.faviconUrl
                    }))
                });
                break;

            case "SAVE_URL_INFO":
                this.props.updateUrlInfo({
                    urlSeq      : data.urlSeq,
                    siteName    : data.siteName,
                    siteAddress : data.siteAddress,
                    faviconUrl  : data.faviconUrl,
                    useYn       : data.useYn
                });
                break;

            case "DELETE_URL":
                this.props.deleteContentUrl({
                    urlSeq: data.urlSeq
                });
                break;

            default:
                break;
        }
    }

    render() {
        if (this.props.userSeq < 0 || !(this.props.isConfigAdmin || this.props.isCreateAdmin)) {
            return <Redirect to="/main" />;
        }

        if (this.props.currentManagePageType === enManagePage.LocalServerHistory) {
            const localServerSeq = Number(this.props.routeProps.match.params.localServerSeq);
            const localServer_info = this.props.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
            const localServerListState = this.props.routeProps.location && this.props.routeProps.location.state ? this.props.routeProps.location.state.localServerListState : null;
            return (
                <WebLocalServerHistory
                    localServerSeq={localServerSeq}
                    localServerName={localServer_info ? localServer_info.localServerName : null}
                    localServerInfo={localServer_info}
                    handleBack={() => this.props.routeProps.history.push("/admin", { localServerListState })}
                />
            );
        }

        if (this.props.currentManagePageType !== enManagePage.SubDomainInfo) {
            const { params } = this.props.routeProps.match;
            const subDomain_info = this.props.list_configSubDomain.find(info => info.subDomainSeq === Number(params.subDomainSeq));

            if (subDomain_info === undefined || subDomain_info === null) {
                return <Redirect to="/admin" />;
            }

            return (
                this.props.currentManagePageType === enManagePage.ConfigSubDomain ?
                    <WebSubDomainDetailConfig
                        subDomain_info={subDomain_info}
                        isChangeLogoOK={this.props.isChangeLogoOK}
                        alertKind={this.props.alertKind}
                        alertMessage={this.props.alertMessage}
                        handleSelectedFunc={this.handleSelectedFunc}
                    /> :
                    <WebSubDomainDetailInfo
                        userSeq={this.props.userSeq}
                        userKind={this.props.userKind}
                        isStandardType={this.props.isStandardType}
                        subDomain_info={subDomain_info}
                        handleSelectedFunc={this.handleSelectedFunc}
                    />
            );
        } else {
            switch (this.props.currentAdminTap) {
                case enAdminTap.Home:
                    return (
                        <>
                            {
                                this.props.isConfigAdmin &&
                                <WebMyConfigSubDomainList
                                    userSeq={this.props.userSeq}
                                    userKind={this.props.userKind}
                                    isStandardType={this.props.isStandardType}
                                    list_subDomainInfo={this.props.list_configSubDomain}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            } {
                                this.props.isCreateAdmin &&
                                <WebMyCreateSubDomainList
                                    userSeq={this.props.userSeq}
                                    userKind={this.props.userKind}
                                    isStandardType={this.props.isStandardType}
                                    alertKind={this.props.alertKind}
                                    alertMessage={this.props.alertMessage}
                                    isCheckSubDomainOK={this.props.isCheckSubDomainOK}
                                    isAddSubDomainOK={this.props.isAddSubDomainOK}
                                    list_subDomainInfo={this.props.list_createSubDomain}
                                    handleSelectedFunc={this.handleSelectedFunc}
                                />
                            }
                        </>
                    );

                case enAdminTap.LocalServer:
                    return (
                        <WebLocalServerConfig
                            selectedUserInfo={this.props.selectedUserInfo}
                            selectedSubDomainInfo={this.props.selectedSubDomainInfo}
                            list_localSite={this.props.list_localSite}
                            list_configLocalServer={this.props.list_configLocalServer}
                            list_localServerType={this.props.list_localServerType}
                            list_configSubDomain={this.props.list_configSubDomain}
                            alertKind={this.props.alertKind}
                            alertMessage={this.props.alertMessage}
                            localServerAlertEventId={this.props.localServerAlertEventId}
                            localServerAlertTarget={this.props.localServerAlertTarget}
                            lastCreatedLocalServerSeq={this.props.lastCreatedLocalServerSeq}
                            initialListState={this.props.routeProps.location && this.props.routeProps.location.state ? this.props.routeProps.location.state.localServerListState : null}
                            handleSelectedFunc={this.handleSelectedFunc}
                        />
                    );

                case enAdminTap.LocalSite:
                    return (
                        <WebLocalSiteConfig
                            list_configLocalSite={this.props.list_configLocalSite}
                            handleSelectedFunc={this.handleSelectedFunc}
                        />
                    );

                case enAdminTap.LiteLocalServer:
                    return (
                        <WebLiteServerConfig
                            selectedSubDomainInfo={this.props.selectedSubDomainInfo}
                            list_configLiteServer={this.props.list_configLiteServer}
                            handleSelectedFunc={this.handleSelectedFunc}
                        />
                    );

                case enAdminTap.Studio:
                    return (
                        <WebStudioContainer
                            currentPageType={this.props.currentPageType}
                        />
                    );

                case enAdminTap.Media:
                    return (
                        <WebMediaConfig
                            media_info={this.props.media_info}
                            list_mediaGateWay={this.props.list_mediaGateWay}
                            handleSelectedFunc={this.handleSelectedFunc}
                        />
                    );

                case enAdminTap.TeacherClass:
                    return (
                        <WebTeacherClassConfig
                            list_contentTeacher={this.props.list_contentTeacher}
                            isNeedTeacherRefresh={this.props.isNeedTeacherRefresh}
                            list_adminLive={this.props.list_adminLive}
                            isNeedClassRefresh={this.props.isNeedClassRefresh}
                            list_contentUrl={this.props.list_contentUrl}
                            isNeedUrlRefresh={this.props.isNeedUrlRefresh}
                            handleSelectedFunc={this.handleSelectedFunc}
                        />
                    );

                default:
                    return <></>;
            }
        }
    }
}

export default connect(
    ({ user, hiclasstv, admin }) => ({
        isConfigAdmin           : user.isConfigAdmin,
        isCreateAdmin           : user.isCreateAdmin,
        isStandardType          : admin.isStandardType,

        userSeq                 : user.userSeq,
        userKind                : user.userKind,

        currentAdminTap         : hiclasstv.currentAdminTap,

        list_localSite          : admin.list_localSite,
        
        list_configSubDomain    : admin.list_configSubDomain,
        list_createSubDomain    : admin.list_createSubDomain,
        list_configLocalServer  : admin.list_configLocalServer,
        list_localServerType    : admin.list_localServerType,
        list_configLocalSite    : admin.list_configLocalSite,
        list_configLiteServer   : admin.list_configLiteServer,

        selectedSubDomainInfo   : admin.selectedSubDomainInfo,
        selectedUserInfo        : admin.selectedUserInfo,

        media_info              : admin.media_info,
        // 260805 관리자 MEDIA 탭용 - 미디어 수프 게이트웨이 서버 전체 목록
        list_mediaGateWay       : admin.list_mediaGateWay,

        list_contentTeacher     : admin.list_contentTeacher,
        isNeedTeacherRefresh    : admin.isNeedTeacherRefresh,

        list_adminLive          : admin.list_adminLive,
        isNeedClassRefresh      : admin.isNeedClassRefresh,

        list_contentUrl         : admin.list_contentUrl,
        isNeedUrlRefresh        : admin.isNeedUrlRefresh,

        isCheckSubDomainOK      : admin.isCheckSubDomainOK,
        isAddSubDomainOK        : admin.isAddSubDomainOK,
        isChangeLogoOK          : admin.isChangeLogoOK,

        alertMessage            : admin.alertMessage,
        alertKind               : admin.alertKind,
        localServerAlertEventId : admin.localServerAlertEventId,
        localServerAlertTarget  : admin.localServerAlertTarget,
        // 260804 로컬 서버 신규 등록 시 자동 페이지 이동을 위해 전달
        lastCreatedLocalServerSeq : admin.lastCreatedLocalServerSeq,
    }),
    {
        selectSubDomainInfo,
        selectUserInfo,

        getPurchasePass,
        getMyManageSubDomainList,

        findUser,
        resetUserLoginStatus,
        resetUserPW,
        duplicateCheckSubDomain,
        addSubDomainInfo,
        addSubDomainConfigAdmin,
        removeSubDomainConfigAdmin,
        addSubDomainCreateAdmin,
        removeSubDomainCreateAdmin,
        selectSubDomainConfigInfo,
        changeSubDomainLogo,
        falseToChangeLogo,
        changeAlertMessage,

        changeShowPassKind,

        createLocalServer,
        getSubDomainLocalServerList,
        reportTokenResetCompleted,
        getUserLocalServerList,
        changeLocalSiteInfo,
        changeLocalServerPortInfo,
        changeLocalServerConfigInfo,
        getLocalServerTypes,
        updateLocalServerTypeUse,
        updateLocalServerTypesUse,
        getLocalServerCommandInfo,
        sendLocalServerCommand,
        // 20260828 로컬 서버 이름 인라인 수정
        changeLocalServerName,

        clearRemoteForwardInfo,

        getLocalSiteList,
        createLocalSite,
        deleteLocalSite,
        classOpenOnLocalSite,
        classCloseOnLocalSite,
        // 20260828 로컬 사이트 이름 인라인 수정
        changeLocalSiteName,

        getLiteServerList,
        createLiteServer,
        changeLiteServerInfo,

        duplicateCheckUsers,
        createUsers,

        getAllContentTeachers,
        createContentTeachers,
        updateTeacherUseYn,
        updateTeacherName,
        updateTeacherInfo,
        deleteContentTeacher,

        getAllLiveList,
        updateLiveInfo,
        deleteLive,

        getAllContentUrls,
        createContentUrls,
        updateUrlInfo,
        deleteContentUrl,

        getMediaGateWayList,
    }
)(WebAdminContainer);
